import ClientsOutlet from "../components/clients/index";
import Dashboard from "../components/pages/dashboard-page";
import EmailVerificationPage from "../components/auth/email-verification";
import ForgotPasswordPage from "../components/auth/forgot-password";
import Layout from "../components/layout";
import LoginPage from "../components/auth/login-page";
import Messenger from "../components/chat/index";
import NotFound from "../components/errors/not-found";
import NotificationsList from "../components/notifications/index";
import Parameters from "../components/pages/parameters-page";
import ResetPasswordPage from "../components/auth/reset-password";
import SetPasswordPage from "../components/auth/set-password";
import Settings from "../components/pages/settings-page";
import Template from "../components/pages/template-page";
import UsersOutlet from "../components/users/index";
import ActivityPage from "../components/pages/activity-page";
import DrinkingWaterTasksPage from "../components/pages/drinking-water-tasks-page";
import TaskSearchPage from "../components/pages/task-search-page";
import AllDrinkingWaterBuildingsPage from "../components/pages/all-drinking-water-buildings-page";
import ImprintPage from "../components/pages/imprint-page";
import ComponentOutlet from "../components/shared/component-outlet";
import { RouterModel } from "../models/router.model";
import {
  ClientsRoute,
  ProductsRoute,
  RolesRoute,
  UsersRoute,
  ActivityRoute,
  DrinkingWaterTasksRoute,
  TaskSearchRoute,
  AllDrinkingWaterBuildingsRoute,
} from "./nested-routes";
import ACInternDownload from "../components/pages/ACIntern-downloads";
import KundenDownloads from "../components/pages/kunden-downloads";
import C3Guide from "../components/pages/c3-guide"; 
import ForbiddenPage from "../components/errors/forbidden";
import UsersCahngeForm from "../components/users/users-change-form";
import microbiologicalSettings from "../components/pages/microbiological-settings";

/**
 * Defines all public and protected routes for the application.
 * Each route specifies a path, title, and the associated component to be rendered.
 */
export const PUBLIC_ROUTES: RouterModel[] = [
  {
    path: "/imprint",
    title: "Imprint",
    Component: ImprintPage,
  },
  {
    path: "/forbidden",
    title: "Forbidden",
    Component: ForbiddenPage,
  },
  {
    path: "/login",
    title: "Login",
    Component: LoginPage,
  },
  {
    path: "*",
    title: "Not Found",
    Component: NotFound,
  },
  {
    path: "/forgot-password",
    title: "Forgot Password",
    Component: ForgotPasswordPage,
  },
  {
    path: "/set-password",
    title: "Set password",
    Component: SetPasswordPage,
  },
  {
    path: "/reset-password",
    title: "Reset password",
    Component: ResetPasswordPage,
  },
  {
    path: "/api/auth/email/verify/:id/:hash",
    title: "Email Verification",
    Component: EmailVerificationPage,
  },
  {
    path: "",
    Component: Layout,
    children: [
      {
        path: "dashboard",
        title: "Dashboard",
        Component: Dashboard,
      },
      {
        path: "messenger",
        title: "Messenger",
        Component: Messenger,
      },
      {
        path: "template",
        title: "Template",
        Component: Template,
      },
      {
        path: "parameters",
        title: "Parameters",
        Component: Parameters,
      },
      {
        path: "clients",
        title: "Clients",
        Component: ClientsOutlet,
        children: ClientsRoute,
      },
      {
        path: "products",
        title: "Products",
        Component: ComponentOutlet,
        children: ProductsRoute,
      },
      {
        path: "roles",
        title: "Roles",
        Component: ComponentOutlet,
        children: RolesRoute,
      },
      {
        path: "users",
        title: "Users",
        Component: UsersOutlet,
        children: UsersRoute,
      },
      {
        path: "notifications",
        title: "Notifications",
        Component: NotificationsList,
      },
      {
        path: "settings",
        Component: ComponentOutlet,
        children: [
          {
            path: "",
            title: "Settings",
            Component: Settings,
          },
          {
            path: "microbiological-settings",
            title: "Microbiological settings",
            Component: microbiologicalSettings,
          },
          {
            path: "change-password",
            title: "Change password",
            Component: UsersCahngeForm,
          },
        ]
      },
      {
        path: "/impressum",
        title: "Imprint",
        Component: ImprintPage,
      },
      {
        path: "activity",
        title: "Activity",
        Component: ActivityPage,
        children: ActivityRoute,
      },
      {
        path: "drinking-water-tasks",
        title: "Drinking Water Tasks",
        Component: DrinkingWaterTasksPage,
        children: DrinkingWaterTasksRoute,
      },
      {
        path: "task-search",
        title: "Task Search",
        Component: TaskSearchPage,
        children: TaskSearchRoute,
      },
      {
        path: "all-drinking-water-buildings",
        title: "All Drinking Water Buildings",
        Component: AllDrinkingWaterBuildingsPage,
        children: AllDrinkingWaterBuildingsRoute,
      },
      {
        path: "acintern-download",
        title: "AC Intern",
        Component: ACInternDownload,
      },
      {
        path: "kunden-downloads",
        title: "Kunden",
        Component: KundenDownloads,
      },
      {
        path: "c3-guide",
        title: "c3 Anleitungen",
        Component: C3Guide,
      },
    ],
  },
];
